import {Component, OnInit, TemplateRef} from '@angular/core';
import {CommonComponent} from '../../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {IContactUs} from '../../../domain/IContactUs';
import {NgForm} from '@angular/forms';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {CustomerProfileService} from '../../../services/customer-profile.service';
import {DialogService} from 'primeng/dynamicdialog';
import {CountryCode} from '../../../entity/CountryCodeEntity';
import {ConfigurationService} from '../../../services/configuration.service';
import {AccountService} from '../../../services/account.service';
import {ReCaptchaV3Service} from 'ng-recaptcha';

@Component({
  selector: 'app-contact-us-account',
  templateUrl: './contact-us-account.component.html',
  styleUrls: ['./contact-us-account.component.scss']
})
export class ContactUsAccountComponent extends CommonComponent implements OnInit {
  contactData: IContactUs = {};
  formSubmitAttempt: boolean;
  countryCodes: CountryCode[] = [];
  constructor(
    private accountService: AccountService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    public configurationService: ConfigurationService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.countryCodes = this.countryCodeCatalog(this.configurationService.application);
    });
  }

  ngOnInit(): void {
    this.countryCodes = this.countryCodeCatalog(this.configurationService.application);
    this.formSubmitAttempt = false;
    this.contactData = {
      comments: null
    };
  }
  generateRecaptcha(form: NgForm){
    this.recaptchaV3Service.execute('send_otp').subscribe((token) => {
      this.contactData.reCaptchaToken = token;
      this.onSubmit(form);
    }, error => {
      this.msgError(error, this.translate.instant('shared.common.general_error_message'));
    }
    );
  }
  onSubmit(form: NgForm) {
    this.formSubmitAttempt = true;
    this.accountService.sendContactUs(this.contactData).subscribe(
      (response: any) => {
        this.msgSuccess(this.translate.instant('shared.contact_us.message_success', {
          email: this.configurationService.home.contactEmail,
          Default: `Mensaje enviado correctamente. Te contactaremos desde la dirección ${this.configurationService.home.contactEmail}`
        }));
      }, error => {
        this.msgError(error);
      }
    );
    form.resetForm();
  }

  openModal(content: TemplateRef<any>): void {
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }
}
